/**
 * character Data 관리 클래스
 * @category character
 * @memberof module:character
 * @param  {Object} _config={} 설정
 */
class DataStore {
    constructor(_config={}){
        this.data = {
            config: _config,
        };

        this.apiUrlList = {

        };
    }
    /**
     * @param  {String} _key='subsub'  요청할 데이터의 키네임
     * @param  {Object} _param={} 요청시 추가할 파라미터 데이터
     * @param  {Function} _callback=()=>{} 요청 완료후 데이터 전달할 콜백 함수
     * @category testApp
     * @returns {Object} Json 데이타
     * @example
     * const appConfig = getData('sub1', {page: 1,per_page: 12}, this.render.bind(this));
     */

    getData(_key = '', _param={}, _callback = ()=>{}){
        if( this.data[_key] ){
            _callback(this.data[_key]);
        }else{
            axios.get(this.apiUrlList[_key], {
                params: _param,
                withCredentials: true
            })
                .then( (response) => {
                    this.data[_key] = response.data;
                    _callback(response.data);
                })
                .catch( (error) => {
                    console.log(error);
                })
                .then( () => {
                    // always executed
                });
        }
    }

    getServerInfoData(_callback = ()=>{}){
        axios.get(`${this.data.config.apiDomain}/game/v1/servers`, {
            withCredentials: true
        })
            .then( (response) => {
                this.data['serverInfoData'] = response.data;
                _callback(response.data);
            })
            .catch( (error) => {
                console.log(error);
            })
            .then( () => {});
    }

    getClassInfoData(_callback = ()=>{}){
        axios.get(`${this.data.config.apiDomain}/game/v1/resource/classes`, {
            withCredentials: true
        })
        .then( (response) => {
            this.data['classInfoData'] = response.data;
            _callback(response.data);
        })
        .catch( (error) => {
            console.log(error);
        })
        .then( () => {});
    }
//https://api-search.sb.plaync.com/bns/search/v2/character?keyword=test&page=1&sort=rank-desc&page=
//https://api-search.sb.plaync.com/bns/search/v2/character?keyword=test&page=1&size=2&zone=qatest


    getResultInfoData(_searchQuery, _callback = ()=>{}){
      console.log(_searchQuery);
        axios.get(`${this.data.config.searchApiDomain}/bns/search/v2/character` + _searchQuery, {

            withCredentials: true
        })
            .then( (response) => {
                this.data['resultInfoData'] = response.data;
                _callback(response.data);
            })
            .catch( (error) => {
                console.log(error);
            })
            .then( () => {});
    }


} // end of class
export default DataStore;